import React, { FC } from "react";
import { ContactUs } from "components";

export const ContactUsView: FC = () => {
  return <ContactUs />;
};
